import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchTemplates(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/${agro_exporter_process_id}/${container_id}`
    );
  },
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}/container/${container_id}`
    );
  },
};
